/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { EventField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedEventModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related event"
    subtitle="Find event related to this article"
    okText="ADD EVENT"
    onSubmit={({ event }) => onSubmit(event)}
  >
    <EventField
      label="Choose an event:"
      name="event"
      extra={null}
      wrapperCol={{ span: 24 }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Event is required' }]}
    />
  </RelatedContentModal>
);

const Item = (event) => <InfoItem>{event.name}</InfoItem>;

RelatedEventModal.Item = Item;

export default RelatedEventModal;
